import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../App';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { XCircle, ArrowRight } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const dashboardPath = user?.role === 'creator' ? '/creator' : '/brand';

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <Card className="max-w-md w-full">
        <CardContent className="pt-8 pb-6 text-center">
          <div className="w-16 h-16 rounded-full bg-destructive/20 flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-8 h-8 text-destructive" />
          </div>
          
          <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Plus Jakarta Sans' }}>
            Payment Cancelled
          </h1>
          <p className="text-muted-foreground mb-6">
            Your payment was cancelled. No charges were made.
          </p>

          <Button 
            onClick={() => navigate(dashboardPath)}
            className="w-full"
            data-testid="back-dashboard-btn"
          >
            Back to Dashboard
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
